
import React, { useState, useCallback } from 'react';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CheckCircleIcon  from '@mui/icons-material/CheckCircle';
import './ExportGeoJsonButton.css';

const ExportGeoJsonButton = ({ onExport, disabled = false }) => {
  const [status, setStatus] = useState('idle'); // idle | exporting | done | error

  const handleClick = useCallback(() => {
    if (disabled || status !== 'idle') return;

    setStatus('exporting');
    // Petite latence artificielle pour laisser l'animation respirer
    setTimeout(() => {
      const ok = onExport?.();
      if (ok === false) {
        setStatus('error');
        setTimeout(() => setStatus('idle'), 1600);
      } else {
        setStatus('done');
        setTimeout(() => setStatus('idle'), 1800);
      }
    }, 350);
  }, [onExport, disabled, status]);

  const label =
    status === 'done'      ? 'Exporté !' :
    status === 'error'      ? 'Aucune donnée' :
    status === 'exporting'  ? 'Export en cours…' :
    'Exporter en GeoJSON';

  return (
    <button
      className={`egj-btn egj-btn--${status} ${disabled ? 'egj-btn--disabled' : ''}`}
      onClick={handleClick}
      disabled={disabled || status !== 'idle'}
      title="Exporter la simulation sélectionnée au format GeoJSON"
    >
      <span className="egj-btn__ring" />
      <span className="egj-btn__icon">
        {status === 'done' ? (
          <CheckCircleIcon style={{ fontSize: 16 }} />
        ) : (
          <FileDownloadIcon
            style={{ fontSize: 16 }}
            className={status === 'exporting' ? 'egj-btn__icon-bounce' : ''}
          />
        )}
      </span>
      <span className="egj-btn__label">{label}</span>
    </button>
  );
};

export default ExportGeoJsonButton;